import { render } from "./SystemPay.vue?vue&type=template&id=2623b779&scoped=true"
import script from "./SystemPay.vue?vue&type=script&lang=js"
export * from "./SystemPay.vue?vue&type=script&lang=js"

import "./SystemPay.vue?vue&type=style&index=0&id=2623b779&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2623b779"]])

export default __exports__